import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from "./PageContext";
import OrderedDataTable from './OrderedDataTableCopy.jsx'; 
import AdditionalDetailsRow from './AdditionalDetailsRow'; 
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AdditionalDetailsModal = () => {
    // initialize PageContext
    const {
        showAdditionalDetailsModal,
        setShowAdditionalDetailsModal,
        showSpinner, 
        rebateSetupDataList, 
        additionalDetailsTableHeader, 
        additionalDetailsRow, 
    } = useContext(PageContext);

    // initialize state
    const [additionalDetailsDataList, setAdditionalDetailsDataList] = useState([]); 

    // function wrapper to pass row component to datatable
    const RowComponent = (row, count, tableHeader) =>{
        return(
            <>
                <AdditionalDetailsRow row={row} count={count} tableHeader={tableHeader} />
            </>
        );
    } 

    // useEffect to run on row change
    useEffect(() => {
        console.log(additionalDetailsRow); 
        // set dataList 
        setAdditionalDetailsDataList(additionalDetailsDataList => additionalDetailsDataList = [additionalDetailsRow]); 
    }, [additionalDetailsRow]); 

    useEffect(() => {
        console.log(additionalDetailsDataList);
    }, [additionalDetailsDataList]); 

    return (
        <>
            <CCOffcanvas
                title={`Additional Details for Setup Id: ${additionalDetailsRow['incentivesetupid']}`}
                show={showAdditionalDetailsModal}
                onCanvasClose={() => setShowAdditionalDetailsModal(showAdditionalDetailsModal => showAdditionalDetailsModal = false)}
                bodyCssClassName="offcanvas-body"
                offCanvasClassName="offcanvas-parent-card"
            >   
                <div className="d-flex flex-column h-100">
                    <div className="p-3 pt-1 trail-section flex-grow-1 overflow-scroll">
                        <div className="bg-white trail-card">
                            <OrderedDataTable sortingEnabled={true} varHeight='145px' RowComponent={RowComponent} tableHeader={additionalDetailsTableHeader} dataList={additionalDetailsDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='7vh'/>
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent
                            tag={"OK"}
                            border={'#fcd800 1px solid'}
                            background={'#fcd800'}
                            color={'#001317'}
                            onButtonClick={() => setShowAdditionalDetailsModal(showAdditionalDetailsModal => showAdditionalDetailsModal = false)}
                        />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default AdditionalDetailsModal; 